export default "__VITE_ASSET__fLsj4ywb__"